import { render, staticRenderFns } from "./TvaBreadcrumb.vue?vue&type=template&id=f1775b48&scoped=true&"
import script from "./TvaBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./TvaBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./TvaBreadcrumb.vue?vue&type=style&index=0&id=f1775b48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1775b48",
  null
  
)

export default component.exports